const grey = {
    50: '#F6F6F9',
    100: '#ECEDF4',
    150: '#DCDFEA',
    200: '#C3C7DB',
    300: '#A4ACC8',
    400: '#8690B6',
    500: '#717CA4',
    600: '#606990',
    700: '#4C5674',
    800: '#3A4359',
    850: '#2A3040',
    900: '#151721',
    950: '#0A0C10'
};
export { grey };

//# sourceMappingURL=grey.js.map